import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { submit } from "redux-form";

import { history } from "../../../store";
import { RootState, Dispatch } from "../../../store/types";
import { Product } from "../../../models";
import { MetaTags } from "../../../head";

import { Wrapper } from "../../../components";
import { Step4State } from "../reducer";
import * as actions from "../actions";
import * as selectors from "../selectors";
import * as constants from "../constants";
import { selectors as step1Selectors, State as Step1State } from "../../Step1";
import { ProjectInfoFormValues } from "./ProjectInfoForm";
import { ATT_MATRIX_VALS } from "../../Wizard/constants";
import ProjectInfoForm from "./ProjectInfoForm";
import FormHeader from "./FormHeader";
import WizardFormLayout from "../../Wizard/components/WizardFormLayout";

export interface Step4ContainerProps extends Step4State, Step1State {
  currFormValues: ProjectInfoFormValues;
  savedFormValues: ProjectInfoFormValues;
  quantityUnit: string;
  fetchStep4Data: () => void;
  fetchEstimateData: () => void;
  toggleDefDimension: () => void;
  saveFormValues: (v: Partial<ProjectInfoFormValues>) => void;
  handleFormSubmit: () => void;
  triggerFormSubmit: () => void;
}

interface Step4ContainerState {
  showAdvanced: boolean;
}

class Step4Container extends React.Component<
  Step4ContainerProps,
  Step4ContainerState
> {
  public state: Step4ContainerState = {
    showAdvanced: false,
  };

  public componentDidMount() {
    // Fetch data if not available
    if (!this.props.industries.length && this.props.chosenProduct) {
      this.props.fetchStep4Data();
    }
  }

  public componentWillUnmount() {
    this.props.saveFormValues(this.props.currFormValues);
  }

  public render() {
    // Go to step 1 if no product chosen
    if (!this.props.chosenProduct) {
      return <Redirect to="/wizard/step-1" />;
    }

    return (
      <Wrapper>
        <MetaTags title="Thông tin đơn hàng" />
        <WizardFormLayout
          leftColPreMatter="Vui lòng điền đẩy đủ các thông tin dưới đây"
          rightColPreMatter="Lựa chọn kiểu bố cục mà bạn thích để chúng tôi có thể tham khảo"
          actionBtn={this.renderSubmitButton()}
          formHeader={this.renderFormHeader()}
          hasTOC={false}
        >
          <ProjectInfoForm
            onSubmit={this.props.handleFormSubmit}
            chosenProduct={this.props.chosenProduct}
            initialValues={this.getInitFormValues()}
            industryOptions={this.renderIndustryOptions()}
            toggleAdvancedFields={this.toggleAdvancedFields}
            {...this.props}
            {...this.state}
          />
        </WizardFormLayout>
      </Wrapper>
    );
  }

  private renderFormHeader = () => (
    <FormHeader
      goBack={() => history.replace("/wizard/step-3")}
      chosenProduct={this.props.chosenProduct as Product}
    />
  );

  private renderSubmitButton = () => (
    <button
      className="action-btn"
      type="button"
      onClick={this.props.triggerFormSubmit}
    >
      Tiếp theo
    </button>
  );

  private renderIndustryOptions = () =>
    this.props.industries.map(industry => (
      <option key={industry.id} value={industry.id}>
        {industry.name}
      </option>
    ));

  /**
   * Sets certain form field values to either their defaults, the user-entered form values,
   * or saved form values (from previous form usage) depending on their related radio button states.
   */
  private getInitFormValues(): Partial<ProjectInfoFormValues> {
    const {
      chosenProduct,
      savedFormValues,
      currFormValues,
      useDefaultDimensions,
      industries,
    } = this.props;
    if (!chosenProduct) {
      return savedFormValues;
    }

    // Pick the first industry, if loaded
    const industryId = industries.length
      ? industries[0].id.toString()
      : undefined;

    return {
      dimension_height: useDefaultDimensions
        ? chosenProduct.default_dimension_height
        : currFormValues.dimension_height,
      dimension_width: useDefaultDimensions
        ? chosenProduct.default_dimension_width
        : currFormValues.dimension_width,
      dimension_depth: useDefaultDimensions
        ? chosenProduct.default_dimension_depth
        : currFormValues.dimension_depth,
      page_number:
        chosenProduct.attribute.page_number !== ATT_MATRIX_VALS.NA
          ? "1"
          : undefined,
      industry:
        chosenProduct.attribute.industry !== ATT_MATRIX_VALS.NA
          ? industryId
          : undefined,
      ...this.props.savedFormValues,
    };
  }

  private toggleAdvancedFields = () =>
    this.setState(state => ({ ...state, showAdvanced: !state.showAdvanced }));
}

const mapStateToProps = (state: RootState): Partial<Step4ContainerProps> => ({
  industries: selectors.industries(state),
  isDataLoading: selectors.isDataLoading(state),
  currFormValues: selectors.currFormValues(state),
  savedFormValues: selectors.savedFormValues(state),
  useDefaultDimensions: selectors.useDefaultDimensions(state),
  chosenProduct: step1Selectors.chosenProduct(state),
  quantityUnit: selectors.quantityUnit(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<Step4ContainerProps> => ({
  fetchStep4Data: () => dispatch(actions.fetchStep4Data()),
  toggleDefDimension: () => dispatch(actions.toggleDimension()),
  handleFormSubmit: () => history.push("/wizard/step-5"), // go to next step
  saveFormValues: (v: Partial<ProjectInfoFormValues>) =>
    dispatch(actions.setProjectFormValues(v)), // persist form values
  triggerFormSubmit: () => dispatch(submit(constants.PROJECT_INFO_FORM)), // trigger redux-form submission
});

export default connect(mapStateToProps, mapDispatchToProps)(Step4Container);



// WEBPACK FOOTER //
// ./src/routes/Step4/components/Step4Container.tsx